(function () {
    'use strict';

    angular
        .module('expenses')
        .controller('ExpensesBySemesterController', ExpensesBySemesterController);
    ExpensesBySemesterController.$inject = ['ExpensesService', 'InvoicesService', 'itemCostCenters', '$uibModal', '$scope'];
    function ExpensesBySemesterController(ExpensesService, InvoicesService, itemCostCenters, $uibModal, $scope) {
        var vm = this;

        vm.flag                  = false;
        vm.expoSelected          = '';
        vm.citySelected          = '';
        vm.typeSelected          = '';
        // vm.selectExpo            = selectExpo;
        // vm.selectCities          = selectCities;
        // vm.selectBoothType       = selectBoothType;
        vm.getByFilter           = getByFilter;
        vm.semesterSelected      = '';
        vm.accountSelected       = '';
        vm.costCenterSelected    = '';
        vm.payee                 = '';
        vm.date                  = {startDate: null, endDate: null};

        vm.options = {
            locale: {
                format: "YYYY-MM-DD" //will give you 2017-01-06
            }
        };

        vm.dateIntervals            = [{id:0, name : 'Semester'},{id: 1, name : 'Date interval'}];
        vm.dateIntervalSelected     = 0;


        vm.selectSemesters   = selectSemesters;
        vm.selectAccounts    = selectAccounts;
        vm.selectPayees      = selectPayees;
        vm.formatPercent     = formatPercent;
        vm.costCenters       = itemCostCenters;

        vm.modal =  modal;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        /* By Category Graph */
        $scope.expensesByCategory = [];
        $scope.expensesByCategory.push({
            data: [0,0],
            bars : {
                show : true,
                barWidth : 0.2,
                order : 1,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        });
        $scope.expensesByCategoryOptions = {
            yaxis: {
                ticks: [0,0]
            },
            colors: ["#edc240"]
        };
        /* Cost Center Graph */
        $scope.expensesByCostCenter = [];
        $scope.expensesByCostCenter.push({
            data : [0,0],
            bars : {
                show : true,
                barWidth : 0.2,
                order : 1,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        });
        $scope.expensesByCostCenterOptions = {
            yaxis: {
                ticks: [0,0]
            },
            colors: ["#fd2525"]
        };
        /* Payee graph */
        $scope.expensesByPayee = [];
        $scope.expensesByPayee.push({
            data : [0,0],
            bars : {
                show : true,
                barWidth : 0.2,
                order : 1,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        });
        $scope.expensesByPayeeOptions = {
            yaxis: {
                ticks: [0,0]
            },
            colors: ["#04a9f4"]
        };
        /* By Bank Account Graph */
        $scope.expensesByBankAccount = [];
        $scope.expensesByBankAccount.push({
            data : [0,0],
            bars : {
                show : true,
                barWidth : 0.2,
                order : 1,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        });
        $scope.expensesByBankAccountOptions = {
            yaxis: {
                ticks: [0,0]
            },
            colors: ["#8bc24a"]
        };

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectSemesters();
            vm.selectAccounts();
        }

        function getByFilter() {
            vm.queryFlag = false;
            vm.query = {};
            vm.query['page']    = vm.page;
            vm.query['semester'] = vm.semesterSelected;
            vm.query['dateInterval'] = vm.dateIntervalSelected;
            if(vm.accountSelected !== '') {
                vm.query['account'] = vm.accountSelected;
            }
            if(vm.costCenterSelected !== '') {
                vm.query['costCenter'] = vm.costCenterSelected;
            }
            if(vm.payee !== '') {
                vm.query['payee'] = vm.payee;
            }
            if(vm.date.startDate !== null) {
                vm.query['startDate'] = vm.date.startDate.format('YYYY-MM-DD');
            }
            if(vm.date.endDate !== null) {
                vm.query['endDate'] = vm.date.endDate.format('YYYY-MM-DD');
            }
            ExpensesService.getExpenses(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.expenses         = response.data;

                // By Category Graph
                var values = [];
                var labels = [];
                angular.forEach(response.data.expensesByCategory.graph.values, function(value, key) {
                    values.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByCategory.graph.labels, function(value, key) {
                    labels.push(value);
                });
                $scope.expensesByCategory = [{
                    data : values,
                    bars : {
                        show : true,
                        barWidth : 0.2,
                        order : 1,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }];
                $scope.expensesByCategoryOptions.yaxis.ticks = labels;
                // By Cost Center Graph
                values = [];
                labels = [];
                angular.forEach(response.data.expensesByCostCenter.graph.values, function(value, key) {
                    values.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByCostCenter.graph.labels, function(value, key) {
                    labels.push(value);
                });
                $scope.expensesByCostCenter = [{
                    data : values,
                    bars : {
                        show : true,
                        barWidth : 0.2,
                        order : 1,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }];
                $scope.expensesByCostCenterOptions.yaxis.ticks = labels;
                // By Payee
                values = [];
                labels = [];
                angular.forEach(response.data.expensesByPayee.graph.values, function(value, key) {
                    values.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByPayee.graph.labels, function(value, key) {
                    labels.push(value);
                });
                $scope.expensesByPayee = [{
                    data : values,
                    bars : {
                        show : true,
                        barWidth : 0.2,
                        order : 1,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }];
                $scope.expensesByPayeeOptions.yaxis.ticks = labels;
                // By Bank Account
                values = [];
                labels = [];
                angular.forEach(response.data.expensesByBankAccount.graph.values, function(value, key) {
                    values.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByBankAccount.graph.labels, function(value, key) {
                    labels.push(value);
                });
                $scope.expensesByBankAccount = [{
                    data : values,
                    bars : {
                        show : true,
                        barWidth : 0.2,
                        order : 1,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }];
                $scope.expensesByBankAccountOptions.yaxis.ticks = labels;
            });
        }

        function selectSemesters () {
            vm.query = {};
            vm.query['expos_ids'] = vm.expoSelected;
            ExpensesService.getExpenseSemesters(vm.query).then(function(response){
                vm.semesters = response.data;
            }).catch(function(err) {
            });
        }

        function selectAccounts () {
            ExpensesService.getExpenseAccounts().then(function(response){
                vm.accounts = response.data;
            }).catch(function(err) {
            });
        }       

        function selectPayees () {
            InvoicesService.getPayees().then(function(response){
                vm.payees = response.data;
            }).catch(function(err) {
            });
        }

        function formatPercent(input)
        {
            return input + '%';
        }

        function modal(items) {

            $uibModal.open({
                templateUrl: 'templates/expenses/reports/expensesbysemester/template.modal.html',
                controller: 'ExpensesBySemesterDetailsController',
                controllerAs:'vm',
                resolve:
                    {
                        items : function () {
                            return items;
                        }
                    }
            });
        }

        activate();
    }
})();